export default [

     {
          path: '/campus',
          name: 'Campus',
          component: () => import("@/views/Page/Campus/Campus.vue"),
           meta: {
               title: '#Default# | Campus',
          },
     }
];